import { useDevice } from "@/components/AppHooks";
import { TDdpMedia } from "@/shared/types";
import { useEffect, useRef } from "react";

export function HomeImgMarquee(props: { images: Array<TDdpMedia> }) {
    const imgRefs = useRef<(HTMLImageElement | null)[]>([]);
    const marqueeRef = useRef<HTMLDivElement>(null);
    const device = useDevice()
    const windowWidth = useRef(0)
    useEffect(() => {
        if (imgRefs.current.every((el) => el !== null) && (device.isDesktop || device.isMobile)) {
            excuteAnimation()
        }
    }, [imgRefs, device])
    const computeTransformWidth = () => {
        if (imgRefs.current.every((el) => el !== null)) {
            const doms = imgRefs.current;
            const gap = 24;
            let _screenWidth = innerWidth;
            let index = 0;
            let finished = false
            while (!finished) {
                if (index >= doms.length) {
                    finished = true;
                }
                if (!finished) {
                    _screenWidth -= (parseFloat(getComputedStyle(doms[index] as HTMLElement).width) + gap);
                }
                index++;
            }
            const keyframes = [
                { transform: 'translateX(0)' },
                { transform: `translateX(-${innerWidth - _screenWidth}px)` }
            ];
            const options = {
                duration: 20000,
                easing: 'linear',
                iterations: Infinity
            };
            marqueeRef.current?.animate(keyframes, options);
        }
    }
    function computeTransformHeight() {
        if (imgRefs.current.every((el) => el !== null)) {
            const doms = imgRefs.current;
            let gap = 24;
            if (innerWidth >= 1024) {
                gap = 24 / 1440 * innerWidth;
            }

            let _screenHeight = innerHeight;
            let index = 0;
            let finished = false
            while (!finished) {
                if (index >= doms.length) {
                    finished = true;
                }
                if (!finished) {
                    _screenHeight -= (parseFloat(getComputedStyle(doms[index] as HTMLElement).height) + gap);
                }
                index++;
            }
            const keyframes = [
                { transform: 'translateY(0)' },
                { transform: `translateY(-${innerHeight - _screenHeight}px)` }
            ];
            const times = 15;
            const options = {
                duration: times * 1000,
                easing: 'linear',
                iterations: Infinity
            };
            marqueeRef.current?.animate(keyframes, options);
        }

    }
    function preloadImages(imgElements: Array<HTMLImageElement>) {
        return new Promise((resolve, reject) => {
            let loadedCount = 0;
            const totalCount = imgElements.length;

            if (totalCount === 0) {
                resolve(true);
                return;
            }

            const checkComplete = () => {
                loadedCount++;
                if (loadedCount >= totalCount) {
                    resolve(true);
                }
            };

            imgElements.forEach(el => {
                if (el.complete) {
                    if (el.naturalWidth > 0) {
                        checkComplete();
                    } else {
                        reject(new Error(`Image failed to load: ${el.src}`));
                    }
                } else {
                    // 未完成：监听 onload / onerror
                    el.onload = () => {
                        checkComplete();
                    };
                    el.onerror = () => {
                        reject(new Error(`Image load error: ${el.src}`));
                    };
                }
            });
        });
    }
    function excuteAnimation() {
        if (windowWidth.current === innerWidth) {
            return
        }
        if (!marqueeRef?.current) return
        windowWidth.current = innerWidth;
        marqueeRef.current?.getAnimations().forEach((animation) => animation.cancel());

        preloadImages(Array.from((marqueeRef.current).childNodes).filter((el) => el instanceof HTMLImageElement) as Array<HTMLImageElement>).then(() => {
            if (device.isMobile) {
                computeTransformWidth();
            }
            if (device.isDesktop) {
                computeTransformHeight();
            }
        })
    }

    return <div ref={marqueeRef} className='image-container'>
        {
            props.images.map((item, index) => (
                <img ref={(el) => {
                    imgRefs.current[index] = el;
                }} key={index} src={`${item.imageS?.url}`} alt={item.altText} />
            ))
        }
        {
            props.images.map((item, index) => (
                <img key={index} src={`${item.imageS?.url}`} alt={item.altText} />
            ))
        }
    </div>
}